import { Flex } from 'antd';

import Loader from '@/UI/Loader';

import { useMagicLinksInit } from './hooks';

const MagicLinkInit = () => {
  useMagicLinksInit();

  return (
    <Flex align="center" justify="center">
      <Loader spinning={true}></Loader>
    </Flex>
  );
};

export default MagicLinkInit;
